import { xhr } from 'go-modules/xhr/xhr';
import type { RealtimeTranscriber } from 'assemblyai';

type WatsonSpeechPromise = Promise<{
	RecognizeStream;
	FormatStream;
	WebAudioL16Stream;
	RealtimeTranscriber?: typeof RealtimeTranscriber;
}>;

class WatsonInitalization {
	private watsonSpeechPromise: WatsonSpeechPromise = null;
	private watsonTokenPromise: Promise<any> = null;

	public speechPromise (heyGenEnabled: boolean = false): WatsonSpeechPromise {
		if (this.watsonSpeechPromise != null) {
			return this.watsonSpeechPromise;
		}

		try {
			return this.watsonSpeechPromise = this.loadWatsonSpeech(heyGenEnabled);
		} catch (e) {
			this.watsonSpeechPromise = null;
			throw e;
		}
	}

	private async loadWatsonSpeech (heyGenEnabled: boolean = false): WatsonSpeechPromise {
		const speechToTextModule = await import(/* webpackChunkName: "watsonSpeechEngine" */ 'watson-speech/speech-to-text');

		if (!heyGenEnabled) {
			return speechToTextModule;
		}

		const assemblyAiModule = await import(/* webpackChunkName: "assemblyaiSpeechEngine" */ 'assemblyai');
		return {
			...assemblyAiModule,
			...speechToTextModule
		};
	}

	public tokenPromise (heyGenEnabled: boolean = false) {
		if (this.watsonTokenPromise != null) {
			return this.watsonTokenPromise;
		}

		let tokenPath = '/watson/token';
		if (heyGenEnabled) {
			tokenPath = '/assemblyai/token';
		}
		return this.watsonTokenPromise = xhr(tokenPath, { method: 'POST'})
			.then((watsonToken: any) => {
				setTimeout(() => {
					this.watsonTokenPromise = null;
				}, watsonToken.expires_in * 0.95 * 1000);
				return watsonToken;
			}).catch((e) => {
				this.watsonTokenPromise = null;
				throw e;
			});
	}

	public reset () {
		this.watsonSpeechPromise = null;
		this.watsonTokenPromise = null;
	}
}

export const watsonSingleton = new WatsonInitalization();
